import React from 'react';
import { SimpleTableTextCellProps } from '../simple-table-row/simple-table-row.props';
import { StyledText } from '../simple-table.styled';
import useMaxWidthForEllipsisWithTooltip from 'components/ellipsis-with-tooltip/hooks/use-max-width-for-ellipsis-with-tooltip';
import EllipsisWithTooltip from 'components/ellipsis-with-tooltip';

const TextCell = <TRow,>({ column, row }: SimpleTableTextCellProps<TRow>) => {
  const { container, maxWidth } = useMaxWidthForEllipsisWithTooltip<HTMLParagraphElement>();
  const tooltipText = column.placeholder?.props.children
    ? (row[column.propName] as string) || column.placeholder?.props.children
    : (row[column.propName] as string);
  const textElement = column.placeholder
    ? (row[column.propName] as string) || column.placeholder
    : (row[column.propName] as string);

  return (
    <StyledText width={column.width || '100%'} ref={container} key={column.title}>
      <EllipsisWithTooltip tooltip={tooltipText} maxWidth={`${maxWidth}px`}>
        <div>{textElement}</div>
      </EllipsisWithTooltip>
    </StyledText>
  );
};

export default TextCell;
